










import {Component, Prop, Mixins} from 'vue-property-decorator'
import Assets from '@/mixins/Assets'

@Component
export default class BrowserMoreImg extends Mixins(Assets) {
  @Prop({default: '', type: String}) name: 'chrome' | 'safari' | 'samsung' | ''
  @Prop({default: 30, type: Number}) height: number
}
